<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex h-full items-stretch gap-6">
    <div class="w-100">
      <app-form-control
        [withBottomMargin]="false"
        label="Grafika">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.previewFile" />
      </app-form-control>
    </div>

    <div class="flex flex-1 flex-col bg-gray-50 p-6">
      <app-form-control label="Nazwa">
        <input
          [formControl]="form.controls.name"
          appPrimengInputText
          pInputText
          placeholder="Wprowadź opis" />
      </app-form-control>

      <app-form-control label="Dostępna">
        <p-toggle-button
          [formControl]="form.controls.isActive"
          offLabel="Nie"
          onLabel="Tak" />
      </app-form-control>

      <app-form-control label="Opis">
        <app-summernote
          [formControl]="form.controls.description"
          [uploadFn]="uploadFn()" />
      </app-form-control>

      <div class="mt-auto flex justify-end">
        <p-button
          [disabled]="form.invalid"
          appPrimengButton
          label="Zapisz"
          severity="primary"
          type="submit" />
      </div>
    </div>
  </div>
</form>
